<template>
  <el-button
    type="primary"
    class="advanced-options-button"
    :class="active && 'active'"
    @click="$emit('click')"
  >
    <div class="d-flex">
      <span class="mr-4">
        {{ $t("sections.common.search.showMoreButton") }}
      </span>
      <font-awesome-icon icon="fa-regular fa-chevron-down" />
    </div>
  </el-button>
</template>
<script>
export default {
  name: 'ShowAdvancedButton',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.advanced-options-button {
  height: 46px;
  font-weight: 600;

  i,
  svg {
    transition: 350ms ease-in-out;
  }

  &.active {
    background: var(--quaternary-darkbg);
    border-color: var(--quaternary-darkbg);

    i,
    svg {
      transform: rotate(-180deg);
    }
  }
}
</style>
